import serviceRequest from "utils/request";

const baseUrl = "/api/attendance";

export const getLeakageAttendance = () => {
	return serviceRequest({
		url: `${baseUrl}/get-leakage-attendance`,
		method: "get",
	});
};

export const submitLeakageAttendance = (data) => {
	return serviceRequest({
		url: `${baseUrl}/submit-leakage-attendance`,
		method: "post",
		data,
	});
};

export const updateAttendance = (data) => {
	return serviceRequest({
		url: `${baseUrl}/update-attendance`,
		method: "post",
		data,
		noErrorMessage: true,
	});
};

export const getAttendanceBookedProjects = (params) => {
	return serviceRequest({
		url: `${baseUrl}/get-booked-projects`,
		method: "get",
		params,
	});
};

export const getAttendanceUsers = (params) => {
	return serviceRequest({
		url: `${baseUrl}/get-attendance-users`,
		method: "get",
		params,
	});
};

export const getAttendanceRate = (params) => {
	return serviceRequest({
		url: `${baseUrl}/get-attendance-rate`,
		method: "get",
		params,
	});
};

export const getAttendanceList = (params) => {
	return serviceRequest({
		url: `${baseUrl}/get-attendance-list`,
		method: "get",
		params,
	});
};

export const exportRawData = (params) => {
	return serviceRequest({
		url: `${baseUrl}/export-raw-data`,
		method: "get",
		responseType: "blob",
		params,
	});
};

export const exportMonthlyReport = (params) => {
	return serviceRequest({
		url: `${baseUrl}/export-monthly-report`,
		method: "get",
		responseType: "blob",
		params,
	});
};

export const getAttendanceBookSetup = (params) => {
	return serviceRequest({
		url: `${baseUrl}/bookSetup`,
		method: "get",
		params,
	});
};

export const getAttendanceSignout = () => {
	return serviceRequest({
		url: `${baseUrl}/get-outstanding-incomplete-data`,
		method: "get",
	});
};

export const getUpdateAttendanceWork = (data) => {
	return serviceRequest({
		url: `${baseUrl}/update-attendance-work`,
		method: "post",
		data,
	});
};

export const attendanceSignout = (data) => {
	return serviceRequest({
		url: `${baseUrl}/sign-in-out`,
		method: "post",
		data,
		noErrorMessage: true,
	});
};

export const deleteAttendance = (data) => {
	return serviceRequest({
		url: `${baseUrl}/delete-attendance`,
		method: "post",
		data,
	});
};
